import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { uniqueId } from 'lodash';

import {
   AdditionalCharge,
   AdditionalChargeErrors,
   AdditionalChargeTouched,
} from 'interfaces/addAdditionalChargesForm';

import { ADDITIONAL_CHARGE_PREFIX } from './uniqueIdPrefixes';

export const useAdditionalChargeDefaults = () => {
   const { t } = useTranslation();

   const DEFAULT_ADDITIONAL_CHARGE: () => AdditionalCharge = useCallback(
      () => ({
         uuid: uniqueId(ADDITIONAL_CHARGE_PREFIX),
         chargeType: undefined,
         palletType: undefined,
         palletsAmount: undefined,
         address: undefined,
         otherChargeName: undefined,
         amount: undefined,
      }),
      [],
   );

   const DEFAULT_ADDITIONAL_CHARGE_ERRORS: () => AdditionalChargeErrors = useCallback(
      () => ({
         chargeType: t('additionalCharges.errors.select_type'),
         palletType: false,
         palletsAmount: false,
         address: false,
         otherChargeName: false,
         amount: false,
      }),
      [t],
   );

   const OTHER_TYPE_CHARGE_ERRORS: () => AdditionalChargeErrors = useCallback(
      () => ({
         chargeType: false,
         palletType: false,
         palletsAmount: false,
         address: false,
         otherChargeName: t('form.validations.required'),
         amount: t('form.validations.required'),
      }),
      [t],
   );

   const DAMAGED_LOST_CHARGE_ERRORS: () => AdditionalChargeErrors = useCallback(
      () => ({
         chargeType: false,
         palletType: t('form.validations.required'),
         palletsAmount: t('form.validations.required'),
         address: t('form.validations.required'),
         otherChargeName: false,
         amount: false,
      }),
      [t],
   );

   const DEFAULT_ADDITIONAL_CHARGE_TOUCHED: () => AdditionalChargeTouched = useCallback(
      () => ({
         chargeType: false,
         palletType: false,
         palletsAmount: false,
         address: false,
         otherChargeName: false,
         amount: false,
      }),
      [],
   );

   return {
      DEFAULT_ADDITIONAL_CHARGE,
      DEFAULT_ADDITIONAL_CHARGE_ERRORS,
      OTHER_TYPE_CHARGE_ERRORS,
      DAMAGED_LOST_CHARGE_ERRORS,
      DEFAULT_ADDITIONAL_CHARGE_TOUCHED,
   };
};
